<template>
    <transition name="slide">
        <div class="bg-grey-light w-full max-w-sm h-full tac fixed pin-b z-40 px-4 md:pt-16 shadow-lg overflow-hidden pin-r"
             v-if="show" v-on-clickaway="close">
            <a href="#"
               class="hidden absolute pin-r pin-t w-16 h-16 no-underline text-blue md:flex items-center justify-center"
               @click.prevent="toggle">
                <i class="fal fa-times text-3xl"></i>
            </a>

            <empty :visible="!notifications.length" icon="fa-check" color="green">
                You're all good. There are no unread notifications right now.
            </empty>
            <div class="-mx-4" v-if="notifications.length">
                <list>
                    <list-item url="#" v-for="notification in notifications"
                               :key="notification.id"
                               @click.native.prevent @click="navigate(notification)">
                        <template slot="icon">
                            <i class="fal" :class="getIcon(notification.data)"></i>
                        </template>
                        <template slot="title">
                            {{notification.data.title}}
                        </template>
                        <template slot="sub-title">
                            {{notification.created_at}}
                        </template>
                    </list-item>
                </list>
            </div>
        </div>
    </transition>
</template>

<script>
    import {mapState} from 'vuex'
    import {mixin as clickaway} from 'vue-clickaway'

    export default {

        mixins: [clickaway],

        computed: {
            ...mapState(['notifications']),
        },

        data() {
            return {
                show: false
            }
        },


        methods: {
            navigate(notification) {
                this.$notificationRead(notification)
                this.$router.push(notification.data.url)
            },

            getIcon(data) {
                if (data.type === 'documents') {
                    return 'fa-file'
                }
                return 'fa-flag'
            },

            open() {
                this.show = true;
            },

            close() {
                this.show = false;
            },

            toggle() {
                this.show = !this.show
            },
        },

        watch: {
            $route(to, from) {
                this.show = false
            }
        }
    }
</script>


<style lang="scss">
    .slide-enter-active, .slide-leave-active {
        transition: transform .8s ease, opacity .5s ease;
    }

    .slide-enter, .slide-leave-to {
        transform: translateY(100%);
        opacity: 0;

        @media only screen and (min-width: 768px) {
            transform: translateX(100%) translateY(0);
        }
    }

    .slide-enter-to, .slide-leave {
        transform: translateY(0);
        opacity: 1;

        @media only screen and (min-width: 768px) {
            transform: translateX(0) translateY(0);
        }
    }
</style>